exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swal2-styled.swal2-cancel{color:#dcfe54!important;font-weight:700!important}", ""]);

// exports
